/**
 * Billing account pricing subview — device/feature pricing configuration for
 * the account, driven by its active agreement's virtual-billing and
 * inventory-policy settings. Routed at
 * `/billing/accounts/:accountId/pricing`.
 *
 * Contains:
 * - AccountPricingView — routed child page (default export)
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import UnifiedPricingManager from '@sophocles/components/UnifiedPricingManager';
import { selectBillingAgreementsForAccount } from '@sophocles/features/billing/slice';
import { useBillingAccount } from '@sophocles/views/billing/BillingAccountLayout';

function AccountPricingView() {
  const { accountId } = useParams();
  const { account } = useBillingAccount();
  const agreements = useSelector(selectBillingAgreementsForAccount(accountId));
  const activeAgreement = agreements.length > 0 ? agreements[0] : null;

  return (
    <UnifiedPricingManager
      accountId={account?.id}
      customerId={account?.customer?.id}
      isBilledVirtual={Boolean(activeAgreement?.is_billed_virtual)}
      inventoryPolicy={activeAgreement?.inventory_policy || 'exact'}
    />
  );
}

export default AccountPricingView;
